import React from 'react';
import '@aws-amplify/ui-react/styles.css';

import {
  View, Flex, Text, Heading, TextField, Button, ThemeProvider, Collection
} from "@aws-amplify/ui-react";

const Progress = ({ questions, currentQuestionIndex, setCurrentQuestionIndex, answers, isSubmitted }) => {
  // Function to scroll smoothly to the selected question
  const scrollToQuestion = (index) => {
    const qe = document.getElementsByClassName('question_index_to_scroll_' + currentQuestionIndex)[0];
    if (qe) {
      qe.scrollIntoView({ behavior: 'smooth' });
    }

  };

  return (
      <Collection
          items={questions}
          type="grid"
          templateColumns="repeat(5, 1fr)"
          gap="1rem"
          className="collection-local-styling-example"
      >
        {(question, index) => {
          let buttonClass = 'progress-button';
          if (isSubmitted) {
            buttonClass += answers[index] === question.correct_answer ? ' correct' : ' incorrect';
          } else if (answers[index]) {
            buttonClass += ' answered';
          }
          buttonClass += ` currentQuestionIndex_${index}`

          return (
              <Button
                  className={`${buttonClass} min-width-button`}
                  key={index}
                  onClick={() => {
                    setCurrentQuestionIndex(index);
                    scrollToQuestion(index); // Scroll to the selected question
                  }}
              >
                {index + 1}
              </Button>
          );
        }}
      </Collection>
  );
};

export default Progress;